!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("ReactResponsiveSelect", [], t) : "object" == typeof exports ? exports.ReactResponsiveSelect = t() : e.ReactResponsiveSelect = t();
}(this, function () {
  return function (n) {
    var r = {};

    function o(e) {
      if (r[e]) return r[e].exports;
      var t = r[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
    }

    return o.m = n, o.c = r, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (t, e) {
      if (1 & e && (t = o(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        o.d(n, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 11);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.INITIALISE = "INITIALISE", t.UPDATE_VIA_PROPS = "UPDATE_VIA_PROPS", t.SET_IS_DRAGGING = "SET_IS_DRAGGING", t.SET_OPTIONS_PANEL_OPEN = "SET_OPTIONS_PANEL_OPEN", t.SET_OPTIONS_PANEL_CLOSED = "SET_OPTIONS_PANEL_CLOSED", t.SET_SINGLESELECT_OPTIONS = "SET_SINGLESELECT_OPTIONS", t.SET_MULTISELECT_OPTIONS = "SET_MULTISELECT_OPTIONS", t.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION = "SET_OPTIONS_PANEL_CLOSED_NO_SELECTION", t.SET_OPTIONS_PANEL_CLOSED_ONBLUR = "SET_OPTIONS_PANEL_CLOSED_ONBLUR", t.SET_NEXT_SELECTED_INDEX = "SET_NEXT_SELECTED_INDEX", t.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC = "SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC";
  }, function (e, t, n) {
    "use strict";

    e.exports = n(12);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e, t) {
      var n = t ? "" : " ";
      return e.replace(/\s\s+/g, n).trim();
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    function r() {
      var n = [];
      return function (e, t) {
        if ("object" == typeof t && null !== t) {
          if (-1 !== n.indexOf(t)) return;
          n.push(t);
        }

        return t;
      };
    }

    t.isEqual = function (e, t) {
      return JSON.stringify(e, r()) === JSON.stringify(t, r());
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.nextValidIndex = function (e, t, n) {
      void 0 === n && (n = "INCREMENT");
      var r = e.options,
          o = r.reduce(function (e, t, n) {
        return t.optHeader || e.push(n), e;
      }, []),
          l = -1 === o.indexOf(t);
      return l && "INCREMENT" === n ? r[t + 1] && !r[t + 1].optHeader ? t + 1 : o[0] : l && "DECREMENT" === n ? r[t - 1] && !r[t - 1].optHeader ? t - 1 : o[o.length - 1] : t;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l,
        i = n(0),
        a = "";

    t.handleAlphaNumerical = function (e) {
      var t = e.event,
          n = e.state,
          r = e.RRSClassRef,
          o = n.options;
      n.disabled || (a += t.key, l || (l = !0, setTimeout(function () {
        var e = o.reduce(function (e, t, n) {
          return t.optHeader || t.disabled || !t.text || -1 === t.text.toLowerCase().indexOf(a) || e.push(n), e;
        }, []);
        0 < e.length && r.updateState({
          value: e[0],
          type: i.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC
        }), l = !1, a = "";
      }, 250)));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(16);
    t.multiSelectBroadcastChange = r.multiSelectBroadcastChange;
    var o = n(17);
    t.singleSelectBroadcastChange = o.singleSelectBroadcastChange;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = n(0),
        d = n(18);

    t.handleClick = function (e) {
      var t = e.event,
          n = e.state,
          r = e.RRSClassRef,
          o = n.multiselect,
          l = n.isOptionsPanelOpen,
          i = n.isDragging,
          a = n.disabled,
          s = n.options;

      if (!a && !1 === i) {
        if (t.preventDefault(), t && d.containsClassName(t.target, "rrs__options")) return;
        var c = parseFloat(t.target.getAttribute("data-key"));
        if (s[c] && (!0 === s[c].disabled || !0 === s[c].optHeader)) return;
        if (d.containsClassName(t.target, "rrs__option")) return void r.updateState({
          type: o ? u.SET_MULTISELECT_OPTIONS : u.SET_SINGLESELECT_OPTIONS,
          value: c
        });
        if (l && (d.containsClassName(t.target, "rrs__label") || d.containsClassName(t.target, "rrs"))) return void r.updateState({
          type: u.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION
        }, function () {
          return r.focusButton();
        });
        r.updateState({
          type: l ? u.SET_OPTIONS_PANEL_CLOSED : u.SET_OPTIONS_PANEL_OPEN
        }, function (e) {
          !1 === e.isOptionsPanelOpen && r.focusButton();
        });
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var d = n(0);

    t.handleEnterPressed = function (e) {
      var t = e.event,
          n = e.state,
          r = e.props,
          o = e.RRSClassRef,
          l = n.disabled,
          i = n.isOptionsPanelOpen,
          a = n.multiselect,
          s = n.nextPotentialSelectionIndex,
          c = n.options;

      if (!l) {
        var u = parseFloat(t.target.getAttribute("data-key"));
        c[u] && (!0 === c[u].disabled || !0 === c[u].optHeader) || (a ? o.updateState({
          type: d.SET_MULTISELECT_OPTIONS,
          value: s
        }) : o.updateState({
          type: d.SET_SINGLESELECT_OPTIONS,
          value: s
        }), i ? t.stopPropagation() : r.onSubmit && r.onSubmit(t));
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = n(0),
        i = n(22);

    t.handleKeyUpOrDownPressed = function (e) {
      var t = e.state,
          n = e.RRSClassRef,
          r = e.type,
          o = t.isOptionsPanelOpen;
      t.disabled || (n.updateState({
        type: l.SET_NEXT_SELECTED_INDEX,
        value: i.getNextIndex(r, t)
      }), !1 === o && n.updateState({
        type: l.SET_OPTIONS_PANEL_OPEN
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialState = {
      multiselect: !1,
      name: "",
      options: [],
      isDragging: !1,
      isOptionsPanelOpen: !1,
      altered: !1,
      singleSelectInitialIndex: 0,
      singleSelectSelectedIndex: 0,
      singleSelectSelectedOption: {},
      nextPotentialSelectionIndex: 0,
      multiSelectInitialSelectedIndexes: [0],
      multiSelectSelectedOptions: {
        altered: !1,
        options: []
      },
      multiSelectSelectedIndexes: []
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _r = function r(e, t) {
        return (_r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      return function (e, t) {
        function n() {
          this.constructor = e;
        }

        _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      };
    }(),
        o = this && this.__assign || function () {
      return (o = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var E = n(1),
        y = n(2),
        s = n(0),
        l = n(14),
        b = n(25),
        c = n(6),
        i = n(10),
        a = n(26),
        u = n(3),
        x = n(39),
        I = n(41),
        d = function (n) {
      function e(e) {
        var t = n.call(this, e) || this;
        return t.onHandleKeyEvent = function (e) {
          l.handleKeyEvent({
            event: e,
            RRSClassRef: t,
            state: t.state,
            props: t.props
          });
        }, t.onHandleTouchStart = function () {
          l.handleTouchStart({
            RRSClassRef: t,
            state: t.state
          });
        }, t.onHandleTouchMove = function () {
          l.handleTouchMove({
            RRSClassRef: t,
            state: t.state
          });
        }, t.onHandleClick = function (e) {
          l.handleClick({
            event: e,
            RRSClassRef: t,
            state: t.state
          });
        }, t.onHandleBlur = function () {
          l.handleBlur({
            RRSClassRef: t,
            state: t.state,
            props: t.props
          });
        }, t.state = i.initialState, t.reducer = a.reducer, t.firstLoad = !0, t;
      }

      return r(e, n), e.prototype.componentDidMount = function () {
        var e = this.props,
            t = e.options,
            n = e.noSelectionLabel,
            r = e.selectedValue,
            o = e.selectedValues,
            l = e.name,
            i = e.multiselect,
            a = e.disabled;
        this.updateState({
          type: s.INITIALISE,
          value: {
            options: t,
            noSelectionLabel: n,
            selectedValue: r,
            selectedValues: o,
            name: l,
            multiselect: i,
            disabled: a
          }
        });
      }, e.prototype.componentWillReceiveProps = function (e) {
        u.isEqual(e, this.props) || this.updateState({
          type: s.UPDATE_VIA_PROPS,
          value: o({}, this.props, e)
        });
      }, e.prototype.componentDidUpdate = function (e, t) {
        var n = this.state,
            r = n.singleSelectSelectedOption,
            o = n.multiSelectSelectedOptions,
            l = n.multiselect,
            i = n.altered,
            a = this.props.onChange;
        return this.firstLoad ? this.firstLoad = !1 : (l ? c.multiSelectBroadcastChange(o.options, Boolean(i), a, t.multiSelectSelectedOptions.options) : c.singleSelectBroadcastChange(r, Boolean(i), a, t.singleSelectSelectedOption), !0);
      }, e.prototype.updateState = function (t, e) {
        var n = this.props,
            r = n.onListen,
            o = n.name,
            l = this.reducer(this.state, t);
        this.setState(l, function () {
          e && e(l);
        }), r && r([s.SET_OPTIONS_PANEL_OPEN, s.SET_NEXT_SELECTED_INDEX, s.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC, s.SET_IS_DRAGGING].some(function (e) {
          return t.type === e;
        }), o, t.type);
      }, e.prototype.focusButton = function () {
        var e = this.selectBox && this.selectBox.querySelector(".rrs__button");
        e && e.focus();
      }, e.prototype.render = function () {
        var t = this,
            e = this.props,
            n = e.prefix,
            r = e.caretIcon,
            o = e.disabled,
            l = this.state,
            i = l.altered,
            a = l.hasOptHeaders,
            s = l.isOptionsPanelOpen,
            c = l.isDragging,
            u = l.noSelectionLabel,
            d = l.multiSelectSelectedIndexes,
            p = l.multiSelectSelectedOptions,
            f = l.name,
            S = l.nextPotentialSelectionIndex,
            _ = l.options,
            O = l.singleSelectSelectedIndex,
            v = l.singleSelectSelectedOption,
            m = l.multiselect,
            h = b.getCustomLabelText({
          props: this.props,
          state: this.state
        });
        return E.createElement("div", {
          "data-testid": f,
          "data-name": f,
          className: y.default("\n          rrs\n          " + (!0 === s ? "rrs--options-visible" : "") + "\n          " + (i ? "rrs--has-changed" : "") + "\n          " + (a ? "rrs--has-opt-headers" : "") + "\n        "),
          ref: function ref(e) {
            t.selectBox = e;
          },
          tabIndex: -1,
          onKeyDown: this.onHandleKeyEvent,
          onTouchStart: this.onHandleTouchStart,
          onTouchMove: this.onHandleTouchMove,
          onTouchEnd: this.onHandleClick,
          onMouseDown: this.onHandleClick,
          onBlur: this.onHandleBlur
        }, m ? E.createElement(x.MultiSelect, {
          disabled: Boolean(o),
          isDragging: c,
          caretIcon: r,
          customLabelText: h,
          prefix: n || "",
          name: f,
          multiSelectSelectedOptions: p,
          multiSelectSelectedIndexes: d,
          nextPotentialSelectionIndex: S,
          isOptionsPanelOpen: s,
          options: _,
          selectBoxRef: this.selectBox
        }) : E.createElement(I.SingleSelect, {
          noSelectionLabel: u || "",
          disabled: Boolean(o),
          caretIcon: r,
          prefix: n || "",
          name: f,
          customLabelText: h,
          singleSelectSelectedOption: v,
          singleSelectSelectedIndex: O,
          nextPotentialSelectionIndex: S,
          isOptionsPanelOpen: s,
          options: _,
          selectBoxRef: this.selectBox
        }));
      }, e;
    }(E.Component);

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var u = n(13),
        r = "function" == typeof Symbol && Symbol.for,
        d = r ? Symbol.for("react.element") : 60103,
        c = r ? Symbol.for("react.portal") : 60106,
        o = r ? Symbol.for("react.fragment") : 60107,
        l = r ? Symbol.for("react.strict_mode") : 60108,
        i = r ? Symbol.for("react.profiler") : 60114,
        a = r ? Symbol.for("react.provider") : 60109,
        s = r ? Symbol.for("react.context") : 60110,
        p = r ? Symbol.for("react.concurrent_mode") : 60111,
        f = r ? Symbol.for("react.forward_ref") : 60112,
        S = r ? Symbol.for("react.suspense") : 60113,
        _ = r ? Symbol.for("react.memo") : 60115,
        O = r ? Symbol.for("react.lazy") : 60116,
        v = "function" == typeof Symbol && Symbol.iterator;

    function m(e) {
      for (var t = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < t; r++) {
        n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
      }

      !function (e, t, n, r, o, l, i, a) {
        if (!e) {
          if ((e = void 0) === t) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var s = [n, r, o, l, i, a],
                c = 0;
            (e = Error(t.replace(/%s/g, function () {
              return s[c++];
            }))).name = "Invariant Violation";
          }
          throw e.framesToPop = 1, e;
        }
      }(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
    }

    var h = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        E = {};

    function y(e, t, n) {
      this.props = e, this.context = t, this.refs = E, this.updater = n || h;
    }

    function b() {}

    function x(e, t, n) {
      this.props = e, this.context = t, this.refs = E, this.updater = n || h;
    }

    y.prototype.isReactComponent = {}, y.prototype.setState = function (e, t) {
      "object" != typeof e && "function" != typeof e && null != e && m("85"), this.updater.enqueueSetState(this, e, t, "setState");
    }, y.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, b.prototype = y.prototype;
    var I = x.prototype = new b();
    I.constructor = x, u(I, y.prototype), I.isPureReactComponent = !0;
    var g = {
      current: null
    },
        P = {
      current: null
    },
        N = Object.prototype.hasOwnProperty,
        T = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function C(e, t, n) {
      var r = void 0,
          o = {},
          l = null,
          i = null;
      if (null != t) for (r in void 0 !== t.ref && (i = t.ref), void 0 !== t.key && (l = "" + t.key), t) {
        N.call(t, r) && !T.hasOwnProperty(r) && (o[r] = t[r]);
      }
      var a = arguments.length - 2;
      if (1 === a) o.children = n;else if (1 < a) {
        for (var s = Array(a), c = 0; c < a; c++) {
          s[c] = arguments[c + 2];
        }

        o.children = s;
      }
      if (e && e.defaultProps) for (r in a = e.defaultProps) {
        void 0 === o[r] && (o[r] = a[r]);
      }
      return {
        $$typeof: d,
        type: e,
        key: l,
        ref: i,
        props: o,
        _owner: P.current
      };
    }

    function R(e) {
      return "object" == typeof e && null !== e && e.$$typeof === d;
    }

    var L = /\/+/g,
        M = [];

    function j(e, t, n, r) {
      if (M.length) {
        var o = M.pop();
        return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: t,
        func: n,
        context: r,
        count: 0
      };
    }

    function A(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, M.length < 10 && M.push(e);
    }

    function D(e, t, n) {
      return null == e ? 0 : function e(t, n, r, o) {
        var l = typeof t;
        "undefined" !== l && "boolean" !== l || (t = null);
        var i = !1;
        if (null === t) i = !0;else switch (l) {
          case "string":
          case "number":
            i = !0;
            break;

          case "object":
            switch (t.$$typeof) {
              case d:
              case c:
                i = !0;
            }

        }
        if (i) return r(o, t, "" === n ? "." + k(t, 0) : n), 1;
        if (i = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var a = 0; a < t.length; a++) {
          var s = n + k(l = t[a], a);
          i += e(l, s, r, o);
        } else if ("function" == typeof (s = null === t || "object" != typeof t ? null : "function" == typeof (s = v && t[v] || t["@@iterator"]) ? s : null)) for (t = s.call(t), a = 0; !(l = t.next()).done;) {
          i += e(l = l.value, s = n + k(l, a++), r, o);
        } else "object" === l && m("31", "[object Object]" == (r = "" + t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, "");
        return i;
      }(e, "", t, n);
    }

    function k(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function B(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function w(e, t, n) {
      var r = e.result,
          o = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? H(e, r, n, function (e) {
        return e;
      }) : null != e && (R(e) && (e = function (e, t) {
        return {
          $$typeof: d,
          type: e.type,
          key: t,
          ref: e.ref,
          props: e.props,
          _owner: e._owner
        };
      }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(L, "$&/") + "/") + n)), r.push(e));
    }

    function H(e, t, n, r, o) {
      var l = "";
      null != n && (l = ("" + n).replace(L, "$&/") + "/"), D(e, w, t = j(t, l, r, o)), A(t);
    }

    function U() {
      var e = g.current;
      return null === e && m("321"), e;
    }

    var V = {
      Children: {
        map: function map(e, t, n) {
          if (null == e) return e;
          var r = [];
          return H(e, r, null, t, n), r;
        },
        forEach: function forEach(e, t, n) {
          if (null == e) return e;
          D(e, B, t = j(null, null, t, n)), A(t);
        },
        count: function count(e) {
          return D(e, function () {
            return null;
          }, null);
        },
        toArray: function toArray(e) {
          var t = [];
          return H(e, t, null, function (e) {
            return e;
          }), t;
        },
        only: function only(e) {
          return R(e) || m("143"), e;
        }
      },
      createRef: function createRef() {
        return {
          current: null
        };
      },
      Component: y,
      PureComponent: x,
      createContext: function createContext(e, t) {
        return void 0 === t && (t = null), (e = {
          $$typeof: s,
          _calculateChangedBits: t,
          _currentValue: e,
          _currentValue2: e,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }).Provider = {
          $$typeof: a,
          _context: e
        }, e.Consumer = e;
      },
      forwardRef: function forwardRef(e) {
        return {
          $$typeof: f,
          render: e
        };
      },
      lazy: function lazy(e) {
        return {
          $$typeof: O,
          _ctor: e,
          _status: -1,
          _result: null
        };
      },
      memo: function memo(e, t) {
        return {
          $$typeof: _,
          type: e,
          compare: void 0 === t ? null : t
        };
      },
      useCallback: function useCallback(e, t) {
        return U().useCallback(e, t);
      },
      useContext: function useContext(e, t) {
        return U().useContext(e, t);
      },
      useEffect: function useEffect(e, t) {
        return U().useEffect(e, t);
      },
      useImperativeHandle: function useImperativeHandle(e, t, n) {
        return U().useImperativeHandle(e, t, n);
      },
      useDebugValue: function useDebugValue() {},
      useLayoutEffect: function useLayoutEffect(e, t) {
        return U().useLayoutEffect(e, t);
      },
      useMemo: function useMemo(e, t) {
        return U().useMemo(e, t);
      },
      useReducer: function useReducer(e, t, n) {
        return U().useReducer(e, t, n);
      },
      useRef: function useRef(e) {
        return U().useRef(e);
      },
      useState: function useState(e) {
        return U().useState(e);
      },
      Fragment: o,
      StrictMode: l,
      Suspense: S,
      createElement: C,
      cloneElement: function cloneElement(e, t, n) {
        null == e && m("267", e);
        var r = void 0,
            o = u({}, e.props),
            l = e.key,
            i = e.ref,
            a = e._owner;

        if (null != t) {
          void 0 !== t.ref && (i = t.ref, a = P.current), void 0 !== t.key && (l = "" + t.key);
          var s = void 0;

          for (r in e.type && e.type.defaultProps && (s = e.type.defaultProps), t) {
            N.call(t, r) && !T.hasOwnProperty(r) && (o[r] = void 0 === t[r] && void 0 !== s ? s[r] : t[r]);
          }
        }

        if (1 === (r = arguments.length - 2)) o.children = n;else if (1 < r) {
          s = Array(r);

          for (var c = 0; c < r; c++) {
            s[c] = arguments[c + 2];
          }

          o.children = s;
        }
        return {
          $$typeof: d,
          type: e.type,
          key: l,
          ref: i,
          props: o,
          _owner: a
        };
      },
      createFactory: function createFactory(e) {
        var t = C.bind(null, e);
        return t.type = e, t;
      },
      isValidElement: R,
      version: "16.8.5",
      unstable_ConcurrentMode: p,
      unstable_Profiler: i,
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: g,
        ReactCurrentOwner: P,
        assign: u
      }
    },
        $ = V;
    e.exports = $.default || $;
  }, function (e, t, n) {
    "use strict";

    var s = Object.getOwnPropertySymbols,
        c = Object.prototype.hasOwnProperty,
        u = Object.prototype.propertyIsEnumerable;
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, r, o = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), l = 1; l < arguments.length; l++) {
        for (var i in n = Object(arguments[l])) {
          c.call(n, i) && (o[i] = n[i]);
        }

        if (s) {
          r = s(n);

          for (var a = 0; a < r.length; a++) {
            u.call(n, r[a]) && (o[r[a]] = n[r[a]]);
          }
        }
      }

      return o;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(5);
    t.handleAlphaNumerical = r.handleAlphaNumerical;
    var o = n(15);
    t.handleBlur = o.handleBlur;
    var l = n(7);
    t.handleClick = l.handleClick;
    var i = n(8);
    t.handleEnterPressed = i.handleEnterPressed;
    var a = n(19);
    t.handleKeyEvent = a.handleKeyEvent;
    var s = n(9);
    t.handleKeyUpOrDownPressed = s.handleKeyUpOrDownPressed;
    var c = n(23);
    t.handleTouchMove = c.handleTouchMove;
    var u = n(24);
    t.handleTouchStart = u.handleTouchStart;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var p = n(0),
        f = n(6);

    t.handleBlur = function (e) {
      var t = e.state,
          n = e.RRSClassRef,
          r = e.props,
          o = r.onBlur,
          l = r.multiselect,
          i = t.isOptionsPanelOpen,
          a = t.disabled,
          s = t.altered,
          c = t.singleSelectSelectedOption,
          u = t.multiSelectSelectedOptions;

      if (!a) {
        var d = n.selectBox && !n.selectBox.contains(document.activeElement);
        i && d && n.updateState({
          type: p.SET_OPTIONS_PANEL_CLOSED_ONBLUR
        }), d && o && (l ? f.multiSelectBroadcastChange(u.options, Boolean(s), o) : f.singleSelectBroadcastChange(c, Boolean(s), o));
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3);

    t.multiSelectBroadcastChange = function (e, t, n, r) {
      n && (r && o.isEqual(r, e) || n({
        options: e.map(function (e) {
          return {
            name: e.name || "",
            text: e.text || "",
            value: e.value || ""
          };
        }),
        altered: t
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3);

    t.singleSelectBroadcastChange = function (e, t, n, r) {
      n && (o.isEqual(r, e) || n({
        name: e.name,
        text: e.text,
        value: e.value,
        altered: t
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.containsClassName = function (e, t) {
      return -1 < String(e.className).split(" ").indexOf(t);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(0),
        s = n(20),
        c = n(21),
        u = n(5),
        d = n(7),
        p = n(8),
        f = n(9);

    t.handleKeyEvent = function (e) {
      var t = e.event,
          n = e.state,
          r = e.props,
          o = e.RRSClassRef,
          l = n.multiselect,
          i = n.isOptionsPanelOpen;
      if (!n.disabled) switch (c.preventDefaultForKeyCodes([s.keyCodes.ENTER, s.keyCodes.SPACE, s.keyCodes.ESCAPE, s.keyCodes.UP, s.keyCodes.DOWN], t), /^[a-z0-9]+$/.test(t.key) && u.handleAlphaNumerical({
        event: t,
        RRSClassRef: o,
        state: n
      }), t.keyCode) {
        case s.keyCodes.TAB:
          i && (t.preventDefault(), l && o.updateState({
            type: a.SET_OPTIONS_PANEL_CLOSED
          }, function () {
            return o.focusButton();
          }));
          break;

        case s.keyCodes.ENTER:
          p.handleEnterPressed({
            RRSClassRef: o,
            event: t,
            props: r,
            state: n
          });
          break;

        case s.keyCodes.SPACE:
          i ? d.handleClick({
            event: t,
            state: n,
            RRSClassRef: o
          }) : o.updateState({
            type: a.SET_OPTIONS_PANEL_OPEN
          });
          break;

        case s.keyCodes.ESCAPE:
          o.updateState({
            type: a.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION
          }, function () {
            return o.focusButton();
          });
          break;

        case s.keyCodes.UP:
          f.handleKeyUpOrDownPressed({
            RRSClassRef: o,
            state: n,
            type: "DECREMENT"
          });
          break;

        case s.keyCodes.DOWN:
          f.handleKeyUpOrDownPressed({
            RRSClassRef: o,
            state: n,
            type: "INCREMENT"
          });
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.keyCodes = {
      TAB: 9,
      ENTER: 13,
      SPACE: 32,
      ESCAPE: 27,
      UP: 38,
      DOWN: 40
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.preventDefaultForKeyCodes = function (e, t) {
      e.forEach(function (e) {
        e === t.keyCode && t.preventDefault();
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = n(4);

    t.getNextIndex = function (e, t) {
      var n = t.isOptionsPanelOpen,
          r = t.nextPotentialSelectionIndex,
          o = t.options;

      switch (e) {
        case "INCREMENT":
          return !1 === n ? l.nextValidIndex(t, r, "INCREMENT") : r === o.length - 1 ? l.nextValidIndex(t, 0, "INCREMENT") : l.nextValidIndex(t, r + 1, "INCREMENT");

        case "DECREMENT":
          return !1 === n ? l.nextValidIndex(t, r, "DECREMENT") : 0 === r ? l.nextValidIndex(t, o.length - 1, "DECREMENT") : l.nextValidIndex(t, r - 1, "DECREMENT");

        default:
          return l.nextValidIndex(t, 0, "DECREMENT");
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);

    t.handleTouchMove = function (e) {
      var t = e.state,
          n = e.RRSClassRef,
          r = t.isDragging;
      t.disabled || r || n.updateState({
        type: o.SET_IS_DRAGGING,
        value: !0
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0);

    t.handleTouchStart = function (e) {
      var t = e.state,
          n = e.RRSClassRef;
      t.disabled || n.updateState({
        type: r.SET_IS_DRAGGING,
        value: !1
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getCustomLabelText = function (e) {
      var t = e.state,
          n = e.props,
          r = n.multiselect,
          o = n.customLabelRenderer,
          l = t.multiSelectSelectedOptions,
          i = t.singleSelectSelectedOption;
      return !!o && o(r ? l : i);
    };
  }, function (e, t, n) {
    "use strict";

    var d = this && this.__assign || function () {
      return (d = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var p = n(0),
        f = n(4),
        S = n(27);

    t.reducer = function (e, t) {
      switch (t.type) {
        case p.UPDATE_VIA_PROPS:
        case p.INITIALISE:
          var n = S.getSelectedValueIndex(t.value),
              r = S.getMultiSelectSelectedValueIndexes(t.value, t.value.selectedValues, t.value.noSelectionLabel);
          return d({}, e, {
            hasOptHeaders: t.value.options.some(function (e) {
              return !0 === e.optHeader;
            }),
            multiselect: t.value.multiselect || !1,
            noSelectionLabel: t.value.noSelectionLabel,
            name: t.value.name,
            options: t.value.options,
            altered: t.value.altered || !1,
            disabled: t.value.disabled || !1,
            singleSelectInitialIndex: n,
            singleSelectSelectedIndex: n,
            singleSelectSelectedOption: S.getSingleSelectSelectedOption(t.value, n),
            nextPotentialSelectionIndex: e.nextPotentialSelectionIndex ? e.nextPotentialSelectionIndex : n,
            multiSelectInitialSelectedIndexes: r,
            multiSelectSelectedIndexes: r,
            multiSelectSelectedOptions: {
              options: S.getMultiSelectInitialSelectedOptions(t.value, t.value.selectedValues)
            }
          });

        case p.SET_IS_DRAGGING:
          return d({}, e, {
            isDragging: t.value
          });

        case p.SET_OPTIONS_PANEL_OPEN:
          var o = d({}, e, {
            isOptionsPanelOpen: !0,
            nextPotentialSelectionIndex: function () {
              return e.multiselect ? e.multiSelectSelectedIndexes.length ? f.nextValidIndex(e, e.multiSelectSelectedIndexes[0]) : f.nextValidIndex(e, 0) : f.nextValidIndex(e, e.nextPotentialSelectionIndex);
            }(),
            singleSelectSelectedOption: S.getSingleSelectSelectedOption(e, e.nextPotentialSelectionIndex)
          });
          return S.mergeIsAlteredState(o);

        case p.SET_OPTIONS_PANEL_CLOSED:
          o = d({}, e, {
            isOptionsPanelOpen: !1,
            singleSelectSelectedIndex: e.nextPotentialSelectionIndex,
            singleSelectSelectedOption: S.getSingleSelectSelectedOption(e, e.nextPotentialSelectionIndex)
          });
          return S.mergeIsAlteredState(o);

        case p.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION:
        case p.SET_OPTIONS_PANEL_CLOSED_ONBLUR:
          return d({}, e, {
            isOptionsPanelOpen: !1
          });

        case p.SET_NEXT_SELECTED_INDEX:
          return d({}, e, {
            nextPotentialSelectionIndex: t.value
          });

        case p.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC:
          return d({}, e, {
            isOptionsPanelOpen: !0,
            nextPotentialSelectionIndex: t.value
          });

        case p.SET_SINGLESELECT_OPTIONS:
          var l = d({}, e, {
            nextPotentialSelectionIndex: t.value,
            singleSelectSelectedIndex: t.value,
            isOptionsPanelOpen: !1,
            singleSelectSelectedOption: S.getSingleSelectSelectedOption(e, t.value)
          });
          return S.mergeIsAlteredState(l);

        case p.SET_MULTISELECT_OPTIONS:
          if (!e.noSelectionLabel) {
            var i = 0 === e.multiSelectSelectedIndexes[0] && 1 === e.multiSelectSelectedIndexes.length,
                a = 0 < e.multiSelectSelectedIndexes.length && !i && 0 === t.value && !e.noSelectionLabel,
                s = i && 0 !== t.value;
            if (a) return S.mergeIsAlteredState(S.getInitialMultiSelectOption(e));
            s && (e = S.resetMultiSelectState(e));
          }

          e.noSelectionLabel && e.multiSelectSelectedOptions.options[0].text === e.noSelectionLabel && (e.multiSelectSelectedOptions.options = []);
          var c = f.nextValidIndex(e, t.value),
              u = e.multiSelectSelectedIndexes.indexOf(c);
          return 0 === (l = d({}, e, {
            nextPotentialSelectionIndex: c,
            multiSelectSelectedIndexes: -1 === u ? S.addMultiSelectIndex(e, c) : S.removeMultiSelectIndex(e, u),
            multiSelectSelectedOptions: -1 === u ? S.addMultiSelectOption(e, c) : S.removeMultiSelectOption(e, u)
          })).multiSelectSelectedOptions.options.length && (e.noSelectionLabel ? l = d({}, l, {
            nextPotentialSelectionIndex: e.hasOptHeaders ? f.nextValidIndex(e, -1) : -1,
            multiSelectSelectedOptions: {
              options: S.getMultiSelectInitialSelectedOptions(e)
            }
          }) : e.noSelectionLabel || (l = S.getInitialMultiSelectOption(e))), S.mergeIsAlteredState(l);

        default:
          return e;
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(28);
    t.addMultiSelectIndex = r.addMultiSelectIndex;
    var o = n(29);
    t.addMultiSelectOption = o.addMultiSelectOption;
    var l = n(30);
    t.getInitialMultiSelectOption = l.getInitialMultiSelectOption;
    var i = n(31);
    t.getMultiSelectInitialSelectedOptions = i.getMultiSelectInitialSelectedOptions;
    var a = n(32);
    t.getMultiSelectSelectedValueIndexes = a.getMultiSelectSelectedValueIndexes;
    var s = n(33);
    t.getSelectedValueIndex = s.getSelectedValueIndex;
    var c = n(34);
    t.getSingleSelectSelectedOption = c.getSingleSelectSelectedOption;
    var u = n(35);
    t.mergeIsAlteredState = u.mergeIsAlteredState;
    var d = n(36);
    t.removeMultiSelectIndex = d.removeMultiSelectIndex;
    var p = n(37);
    t.removeMultiSelectOption = p.removeMultiSelectOption;
    var f = n(38);
    t.resetMultiSelectState = f.resetMultiSelectState;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.addMultiSelectIndex = function (e, t) {
      return e.multiSelectSelectedIndexes.concat([t]);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.addMultiSelectOption = function (e, t) {
      return {
        options: e.multiSelectSelectedOptions.options.concat([{
          name: e.name,
          text: e.options[t].text,
          value: e.options[t].value
        }])
      };
    };
  }, function (e, t, n) {
    "use strict";

    var o = this && this.__assign || function () {
      return (o = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getInitialMultiSelectOption = function (e) {
      var t = function (e) {
        var t = e.options,
            r = e.name;
        return t.reduce(function (e, t, n) {
          return t.optHeader || e.push({
            option: {
              value: t.value,
              text: t.text,
              name: r
            },
            index: n
          }), e;
        }, [])[0];
      }(e),
          n = t.option,
          r = t.index;

      return o({}, e, {
        multiSelectSelectedIndexes: [r],
        multiSelectSelectedOptions: {
          options: [o({}, n)]
        },
        nextPotentialSelectionIndex: r
      });
    };
  }, function (e, t, n) {
    "use strict";

    var a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getMultiSelectInitialSelectedOptions = function (e, n) {
      var t,
          r = e.noSelectionLabel,
          o = e.options,
          l = e.name;
      if (r) return t = n && 0 < n.length ? o.reduce(function (e, t) {
        return n.some(function (e) {
          return e === t.value;
        }) && e.push(a({}, t)), e;
      }, []) : [{
        name: e.name,
        text: r,
        value: "null"
      }];
      if (n && 0 < n.length) t = o.filter(function (t) {
        return n.some(function (e) {
          return e === t.value;
        });
      }).map(function (e) {
        return a({
          name: l
        }, e);
      });else {
        var i = o[0] && o[0].optHeader ? function (e) {
          var t = e.multiSelectSelectedOptions,
              n = e.options,
              r = e.name;
          if (t && t.options.length) return t.options[0];
          var o = n.reduce(function (e, t) {
            return t.optHeader || e.push(t), e;
          }, []);
          return {
            name: r,
            text: o[0].text,
            value: o[0].value
          };
        }(e) : o[0];
        t = [{
          name: l,
          text: i.text,
          value: i.value
        }];
      }
      return t;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(4);

    t.getMultiSelectSelectedValueIndexes = function (e, r, t) {
      void 0 === r && (r = []);
      var n = e.options,
          o = t ? [] : [i.nextValidIndex(e, 0)],
          l = n.reduce(function (e, t, n) {
        return r.some(function (e) {
          return t.value === e;
        }) && e.push(n), e;
      }, []);
      return 0 < l.length ? l : o;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSelectedValueIndex = function (e) {
      var t = e.options,
          n = e.selectedValue,
          r = e.noSelectionLabel,
          o = n ? t.map(function (e) {
        return e.value;
      }).indexOf(n) : -1;
      return -1 < o || r ? o : 0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSingleSelectSelectedOption = function (e, t) {
      void 0 === t && (t = 0);
      var n = -1 !== t || e.noSelectionLabel ? t : 0;
      return e.options[n] && e.options[n].optHeader ? function (e) {
        if (e.singleSelectSelectedOption) return e.singleSelectSelectedOption;
        var t = e.options.reduce(function (e, t) {
          return t.optHeader || e.push(t), e;
        }, []);
        return r({}, t[0], {
          name: e.name
        });
      }(e) : e.noSelectionLabel ? -1 < t ? r({
        name: e.name
      }, e.options[t]) : {
        name: e.name,
        text: e.noSelectionLabel,
        value: "null"
      } : r({
        name: e.name
      }, e.options[n]);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    function o(e) {
      return e.multiselect ? !(JSON.stringify(e.multiSelectInitialSelectedIndexes) === JSON.stringify(e.multiSelectSelectedIndexes)) : e.singleSelectSelectedIndex !== e.singleSelectInitialIndex;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isAltered = o, t.mergeIsAlteredState = function (e) {
      return r({}, e, {
        altered: o(e)
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.removeMultiSelectIndex = function (e, t) {
      return e.multiSelectSelectedIndexes.slice(0, t).concat(e.multiSelectSelectedIndexes.slice(t + 1));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.removeMultiSelectOption = function (e, t) {
      return {
        options: e.multiSelectSelectedOptions.options.slice(0, t).concat(e.multiSelectSelectedOptions.options.slice(t + 1))
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(10);

    t.resetMultiSelectState = function (e) {
      return r({}, e, {
        multiSelectSelectedIndexes: o.initialState.multiSelectSelectedIndexes.slice(),
        multiSelectSelectedOptions: r({}, o.initialState.multiSelectSelectedOptions)
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _r2 = function r(e, t) {
        return (_r2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      return function (e, t) {
        function n() {
          this.constructor = e;
        }

        _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var f = n(1),
        S = n(2),
        _ = n(40),
        o = function (n) {
      function e(e) {
        var t = n.call(this, e) || this;
        return t.optionsButton = f.createRef(), t.optionsContainer = f.createRef(), t;
      }

      return r(e, n), e.prototype.componentDidUpdate = function (e) {
        var t = this.props,
            n = t.isOptionsPanelOpen,
            r = t.selectBoxRef;
        !n && e.isOptionsPanelOpen && r && r.contains(document.activeElement) && this.optionsButton.current && this.optionsButton.current.focus();
      }, e.prototype.getAriaLabel = function () {
        var e = this.props,
            t = e.multiSelectSelectedOptions,
            n = e.prefix,
            r = t.options.length;
        return S.default("\n      Checkbox group " + (n ? n + " " : "") + " has\n      " + r + " item" + (1 === r ? "" : "s") + " selected.\n      Selected option" + (1 === r ? "" : "s") + " " + (1 === r ? "is" : "are") + "\n      " + t.options.map(function (e) {
          return e.text || "";
        }).join(" and ") + "\n    ");
      }, e.prototype.render = function () {
        var n = this,
            e = this.props,
            t = e.caretIcon,
            r = e.customLabelText,
            o = e.disabled,
            l = e.isOptionsPanelOpen,
            i = e.multiSelectSelectedIndexes,
            a = e.multiSelectSelectedOptions,
            s = e.name,
            c = e.options,
            u = e.nextPotentialSelectionIndex,
            d = e.prefix,
            p = "";
        return f.createElement("div", null, f.createElement("div", {
          role: "button",
          tabIndex: 0,
          "aria-disabled": o,
          "aria-haspopup": "true",
          "aria-expanded": l,
          "aria-controls": "rrs-" + s + "-menu",
          ref: this.optionsButton,
          className: S.default("\n            rrs__button\n            " + (!0 === o ? "rrs__button--disabled" : "") + "\n          ")
        }, r && f.createElement("div", {
          className: "rrs__label"
        }, f.createElement("span", {
          "aria-label": this.getAriaLabel(),
          className: "rrs__label__text",
          id: "rrs-" + s + "-label",
          "data-testid": "rrs-label_" + s
        }, r), t && t), !r && f.createElement("div", {
          className: "rrs__label"
        }, f.createElement("span", {
          "aria-label": this.getAriaLabel(),
          className: "rrs__label__text",
          id: "rrs-" + s + "-label",
          "data-testid": "rrs-label_" + s
        }, f.createElement("span", {
          className: "rrs__multiselect-label"
        }, f.createElement("span", {
          className: "rrs__multiselect-label__text"
        }, (d ? d + " " : "") + "\n                  " + (0 < a.options.length ? a.options[0].text : "")), 1 < a.options.length && f.createElement("span", {
          className: "rrs__multiselect-label__badge"
        }, "+ " + (a.options.length - 1)))), t && t), s && f.createElement("input", {
          type: "hidden",
          name: s,
          "data-testid": "rrs-input_" + s,
          value: [a.options.map(function (e) {
            return e.value;
          })].join(",")
        })), f.createElement("ul", {
          id: "rrs-" + s + "-menu",
          "aria-labelledby": "rrs-" + s + "-label",
          role: "menu",
          className: "rrs__options",
          ref: this.optionsContainer
        }, 0 < c.length && c.map(function (e, t) {
          return e.optHeader && (p = e.text || e.markup && e.markup.textContent || ""), f.createElement(_.MultiSelectOption, {
            key: t,
            name: s,
            optHeaderLabel: p,
            optionsContainerRef: n.optionsContainer,
            index: t,
            option: e,
            isOptionsPanelOpen: l,
            multiSelectSelectedIndexes: i,
            nextPotentialSelectionIndex: u
          });
        })));
      }, e;
    }(f.Component);

    t.MultiSelect = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _r3 = function r(e, t) {
        return (_r3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      return function (e, t) {
        function n() {
          this.constructor = e;
        }

        _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(2),
        o = function (n) {
      function e(e) {
        var t = n.call(this, e) || this;
        return t.optionRef = s.createRef(), t;
      }

      return r(e, n), e.prototype.getScrollOffset = function () {
        var e = document.querySelector(".rrs__option--header");
        return Math.ceil(e && e.getBoundingClientRect().height || 0);
      }, e.prototype.componentDidUpdate = function () {
        var e = this.props,
            t = e.index,
            n = e.isOptionsPanelOpen,
            r = e.nextPotentialSelectionIndex,
            o = e.optionsContainerRef,
            l = e.optHeaderLabel;

        if (t === r && n && this.optionRef.current && o.current && (this.optionRef.current.focus(), "" !== l)) {
          var i = Math.ceil(this.optionRef.current.getBoundingClientRect().top - o.current.getBoundingClientRect().top);
          this.scrollOffset = this.scrollOffset || this.getScrollOffset(), i < this.scrollOffset && o.current.scroll(0, Math.floor(o.current.scrollTop - this.scrollOffset));
        }
      }, e.prototype.isDisabled = function (e) {
        return Boolean(e.disabled || e.optHeader);
      }, e.prototype.render = function () {
        var e = this.props,
            t = e.index,
            n = e.name,
            r = e.multiSelectSelectedIndexes,
            o = e.nextPotentialSelectionIndex,
            l = e.option,
            i = e.optHeaderLabel,
            a = r.some(function (e) {
          return e === t;
        });
        return s.createElement("li", {
          role: "checkbox",
          "data-testid": "rrs-option_" + n + "_" + t,
          tabIndex: -1,
          "aria-checked": a,
          "aria-label": "\n        " + (l.text || l.markup && l.markup.textContent) + " " + ("" !== i ? " of " + i : "") + "\n      ",
          "aria-live": "assertive",
          "aria-disabled": this.isDisabled(l) ? "true" : "false",
          "data-key": t,
          ref: this.optionRef,
          className: c.default("\n          rrs__option\n          " + (a ? "rrs__option--selected" : "") + "\n          " + (o === t ? "rrs__option--next-selection" : "") + "\n          " + (!0 === l.disabled ? "rrs__option--disabled" : "") + "\n          " + (!0 === l.optHeader ? "rrs__option--header" : "") + "\n        ")
        }, l.markup || l.text);
      }, e;
    }(s.Component);

    t.MultiSelectOption = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _r4 = function r(e, t) {
        return (_r4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      return function (e, t) {
        function n() {
          this.constructor = e;
        }

        _r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var d = n(1),
        p = n(2),
        f = n(42),
        o = function (n) {
      function e(e) {
        var t = n.call(this, e) || this;
        return t.optionsButton = d.createRef(), t.optionsContainer = d.createRef(), t;
      }

      return r(e, n), e.prototype.componentDidUpdate = function (e) {
        var t = this.props,
            n = t.isOptionsPanelOpen,
            r = t.nextPotentialSelectionIndex,
            o = t.selectBoxRef,
            l = !n && e.isOptionsPanelOpen;
        this.optionsButton.current && (l && o && o.contains(document.activeElement) && this.optionsButton.current.focus(), n && -1 === r && this.optionsButton.current.focus());
      }, e.prototype.getCustomLabel = function () {
        var e = this.props,
            t = e.prefix,
            n = e.name,
            r = e.singleSelectSelectedOption,
            o = e.caretIcon,
            l = e.customLabelText;
        return d.createElement("div", {
          className: "rrs__label"
        }, d.createElement("span", {
          "aria-label": (t ? t + " " : "") + r.text + " selected",
          className: "rrs__label__text",
          id: "rrs-" + n + "-label",
          "data-testid": "rrs-label_" + n
        }, l), o && o);
      }, e.prototype.getDefaultLabel = function () {
        var e = this.props,
            t = e.prefix,
            n = e.singleSelectSelectedOption,
            r = e.name,
            o = e.caretIcon,
            l = e.singleSelectSelectedIndex,
            i = e.noSelectionLabel;
        return -1 === l ? d.createElement("div", {
          className: "rrs__label"
        }, d.createElement("span", {
          "aria-label": i,
          className: "rrs__label__text",
          id: "rrs-" + r + "-label",
          "data-testid": "rrs-label_" + r
        }, t && d.createElement("span", null, t), i), o && o) : d.createElement("div", {
          className: "rrs__label"
        }, d.createElement("span", {
          "aria-label": (t ? t + " " : "") + n.text + " selected",
          className: "rrs__label__text",
          id: "rrs-" + r + "-label",
          "data-testid": "rrs-label_" + r
        }, t && d.createElement("span", null, t), n.text ? n.text : d.createElement("div", null, " ")), o && o);
      }, e.prototype.render = function () {
        var n = this,
            e = this.props,
            t = e.customLabelText,
            r = e.disabled,
            o = e.isOptionsPanelOpen,
            l = e.name,
            i = e.nextPotentialSelectionIndex,
            a = e.options,
            s = e.singleSelectSelectedIndex,
            c = e.singleSelectSelectedOption,
            u = "";
        return d.createElement("div", null, d.createElement("div", {
          role: "button",
          tabIndex: 0,
          "aria-disabled": r,
          "aria-haspopup": "true",
          "aria-expanded": o,
          "aria-controls": "rrs-" + l + "-menu",
          ref: this.optionsButton,
          className: p.default("\n            rrs__button\n            " + (!0 === r ? "rrs__button--disabled" : "") + "\n          ")
        }, t ? this.getCustomLabel() : this.getDefaultLabel(), l && d.createElement("input", {
          type: "hidden",
          name: l,
          "data-testid": "rrs-input_" + l,
          value: c.value
        })), d.createElement("ul", {
          id: "rrs-" + l + "-menu",
          "aria-labelledby": "rrs-" + l + "-label",
          role: "menu",
          className: "rrs__options",
          ref: this.optionsContainer
        }, 0 < a.length && a.map(function (e, t) {
          return e.optHeader && (u = e.text || e.markup && e.markup.textContent || ""), d.createElement(f.SingleSelectOption, {
            key: t,
            name: l,
            optHeaderLabel: u,
            optionsContainerRef: n.optionsContainer,
            index: t,
            isOptionsPanelOpen: o,
            option: e,
            singleSelectSelectedIndex: s,
            nextPotentialSelectionIndex: i
          });
        })));
      }, e;
    }(d.Component);

    t.SingleSelect = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _r5 = function r(e, t) {
        return (_r5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      return function (e, t) {
        function n() {
          this.constructor = e;
        }

        _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(2),
        o = function (n) {
      function e(e) {
        var t = n.call(this, e) || this;
        return t.optionRef = a.createRef(), t;
      }

      return r(e, n), e.prototype.getScrollOffset = function () {
        var e = document.querySelector(".rrs__option--header");
        return Math.ceil(e && e.getBoundingClientRect().height || 0);
      }, e.prototype.componentDidUpdate = function () {
        var e = this.props,
            t = e.index,
            n = e.isOptionsPanelOpen,
            r = e.nextPotentialSelectionIndex,
            o = e.optionsContainerRef,
            l = e.optHeaderLabel;

        if (t === r && n && this.optionRef.current && o.current && (this.optionRef.current.focus(), "" !== l)) {
          var i = Math.ceil(this.optionRef.current.getBoundingClientRect().top - o.current.getBoundingClientRect().top);
          this.scrollOffset = this.scrollOffset || this.getScrollOffset(), i < this.scrollOffset && o.current.scroll(0, Math.floor(o.current.scrollTop - this.scrollOffset));
        }
      }, e.prototype.isDisabled = function (e) {
        return Boolean(e.disabled || e.optHeader);
      }, e.prototype.render = function () {
        var e = this.props,
            t = e.index,
            n = e.name,
            r = e.nextPotentialSelectionIndex,
            o = e.option,
            l = e.singleSelectSelectedIndex,
            i = e.optHeaderLabel;
        return a.createElement("li", {
          role: "menuitem",
          "data-testid": "rrs-option_" + n + "_" + t,
          tabIndex: -1,
          "aria-disabled": this.isDisabled(o) ? "true" : "false",
          "aria-label": "\n          " + (o.text || o.markup && o.markup.textContent) + " " + ("" !== i ? " of " + i : "") + "\n        ",
          "data-key": t,
          ref: this.optionRef,
          className: s.default("\n          rrs__option\n          " + (l === t ? "rrs__option--selected" : "") + "\n          " + (r === t ? "rrs__option--next-selection" : "") + "\n          " + (!0 === o.disabled ? "rrs__option--disabled" : "") + "\n          " + (!0 === o.optHeader ? "rrs__option--header" : "") + "\n        ")
        }, o.markup || o.text);
      }, e;
    }(a.Component);

    t.SingleSelectOption = o;
  }]);
});